module.exports = __webpack_public_path__ + "static/media/nortification_register_black.06851b86.svg";